import { render, staticRenderFns } from "./Letrero.vue?vue&type=template&id=0eaff2db&scoped=true"
import script from "./Letrero.vue?vue&type=script&lang=js"
export * from "./Letrero.vue?vue&type=script&lang=js"
import style0 from "./Letrero.vue?vue&type=style&index=0&id=0eaff2db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eaff2db",
  null
  
)

export default component.exports